import React from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { API, get } from "../../config";
import Spin from "../common/Spin";

const InviteAccountingFirm = () => {
  const [loading] = useState(true);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const clientId = query.get("clientId");
  const clientBusinessId = query.get("clientBusinessId");
  const accountingFirmId = query.get("accountingFirmId");
  const accountingFirmEmail = query.get("accountingFirmEmail");
  const accept = query.get("accept");

  localStorage.setItem("invite-clientId", clientId ? clientId : "");
  localStorage.setItem(
    "invite-clientBusinessId",
    clientBusinessId ? clientBusinessId : ""
  );
  localStorage.setItem(
    "invite-accountingFirmId",
    accountingFirmId ? accountingFirmId : ""
  );
  localStorage.setItem(
    "invite-accountingFirmEmail",
    accountingFirmEmail ? accountingFirmEmail : ""
  );
  localStorage.setItem("invite-accept", accept ? accept : "");
  const hasToken = localStorage.getItem("bt-auth-token");

  const logout = useCallback(() => {
    get(API.LOGOUT)
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem("bt-auth-token");
          localStorage.removeItem("bt-auth-email");
          localStorage.removeItem("EmailVerification");
          localStorage.removeItem("userId");
          localStorage.removeItem("ProfilePhoto");
          localStorage.removeItem("Name");
          localStorage.removeItem("role");
          localStorage.removeItem("roleTYpe");
          localStorage.removeItem("clientId");
          localStorage.removeItem("BusinessName");
          accountingFirmId
            ? (window.location.href = "/")
            : (window.location.href = "/signup");
        }
      })
      .catch(() => {
        var error = {};
        error["bt_error"] =
          "There is some issue with request, please try after some time.";
        this.setState({ errors: error });
      });
  }, [accountingFirmId]);

  useEffect(() => {
    hasToken
      ? logout()
      : accountingFirmId
      ? (window.location.href = "/")
      : (window.location.href = "/signup");
  }, [hasToken, logout, accountingFirmId]);

  return (
    <>
      {loading && <Spin />}
      <tetx>Please wait...</tetx>
    </>
  );
};

export default InviteAccountingFirm;
